module.exports = __webpack_public_path__ + "img/6.4ee9053.png";